import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import styles from './CategoryHeader.module.css';

const CategoryHeader = ({ title, subtitle }) => (
  <PageContainer className={styles.categoryHeaderContainer}>
    <h3>{title}</h3>
    <p>{subtitle}</p>
  </PageContainer>
);

CategoryHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default CategoryHeader;
